import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AdvancedReorderRuleModel } from 'src/app/_models/advanced-reorder-rule.model';

interface ReorderCalculationSummary {
  minusInventory?: unknown;
  minusStoreInventory?: unknown;
  minusOverstockedStoreInventory?: unknown;
  minusPOs?: unknown;
  outOfStock?: unknown;
  buyBox?: unknown;
  adjustment?: number;
}

/** Range pickers stay in the parent view so its queries and date-state transfer keep working. */
@Component({
  selector: 'app-reorder-controls',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, NgbTooltipModule],
  templateUrl: './reorder-controls.component.html',
  styleUrls: ['./reorder-controls.component.scss']
})
export class ReorderControlsComponent {
  private static nextId = 0;
  readonly optionsId = `ia-reorder-options-${ReorderControlsComponent.nextId++}`;
  @Input() rules: AdvancedReorderRuleModel[] = [];
  @Input() selectedRule: AdvancedReorderRuleModel;
  @Input() expanded = false;
  @Input() ruleChanged = false;
  @Input() applyToAll = false;
  @Input() summary: ReorderCalculationSummary = {};
  @Input() adjustmentSign = '+';
  @Output() ruleChange = new EventEmitter<AdvancedReorderRuleModel>();
  @Output() ruleCreate = new EventEmitter<void>();
  @Output() applyUpdates = new EventEmitter<void>();
  @Output() settingsOpen = new EventEmitter<void>();
  @Output() expandedChange = new EventEmitter<boolean>();
  @Output() applyScopeChange = new EventEmitter<boolean>();

  get adjustmentPercent(): number { return Math.abs(this.summary?.adjustment || 0) / 100; }

  readonly calculationFlags = [
    { key: 'minusInventory', label: 'Subtract warehouse stock' },
    { key: 'minusStoreInventory', label: 'Subtract store stock' },
    { key: 'minusOverstockedStoreInventory', label: 'Subtract overstocked store stock' },
    { key: 'minusPOs', label: 'Subtract open POs' },
    { key: 'outOfStock', label: 'Exclude out-of-stock days' },
    { key: 'buyBox', label: 'Exclude days without Buy Box' }
  ] as const;
}
